import { useCallback } from 'react';
import { api } from '../../../utils/api.ts';

export function useInvalidateFeed() {
    const apiUtils = api.useUtils();

    return useCallback(() => {
        void apiUtils.platoUser.query.customerActivity.getFeedList.withFilters.invalidate();
    }, [apiUtils.platoUser.query.customerActivity.getFeedList.withFilters]);
}
